import React from 'react';
import { View, Animated } from 'react-native';

const JumpingDots = () => {
  const dot1Animation = new Animated.Value(0);
  const dot2Animation = new Animated.Value(0);
  const dot3Animation = new Animated.Value(0);

  const animateDot = (animation, delay) => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(animation, {
          toValue: 5,
          duration: 200,
          useNativeDriver: true,
          delay: delay,
        }),
        Animated.timing(animation, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        }),
      ])
    ).start();
  };

  React.useEffect(() => {
    animateDot(dot1Animation, 200);
    animateDot(dot2Animation, 400);
    animateDot(dot3Animation, 600);
  }, []);

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
      <Animated.View style={{
        backgroundColor: 'gray',
        width: 12,
        height: 12,
        borderRadius: 6,
        marginRight: 3,
        transform: [{ translateY: dot1Animation }]
      }} />
      <Animated.View style={{
        backgroundColor: 'gray',
        width: 12,
        height: 12,
        borderRadius: 6,
        marginRight: 3,
        transform: [{ translateY: dot2Animation }]
      }} />
      <Animated.View style={{
        backgroundColor: 'gray',
        width: 12,
        height: 12,
        borderRadius: 6,
        marginRight: 3,
        transform: [{ translateY: dot3Animation }]
      }} />
    </View>
  );
};

export default JumpingDots;
